import { formatText } from "../../../_utils/textFormatter";
import "./_progress-stage.scss";

const ProgressStage = ({ currentStage, stages }) => {
  return (
    <div className="progress-stage-container">
      <div className="progress-bar">
        {stages.map((stage, index) => (
          <div
            key={stage}
            className={`progress-segment ${
              index <= currentStage ? `active stage-${currentStage}` : ""
            }`}
          ></div>
        ))}
      </div>
      <div className="stage-labels">
        {stages.map((stage) => (
          <span key={stage} className="stage-label">
            {formatText(stage)}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ProgressStage;
